import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config.json";
import { buildScheduleTiming } from "./scheduleDeviation";

export default function useVehicleScheduleTiming(vehicleId, organizationId) {
  const [timing, setTiming] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let timer;
    setTiming(null);
    if (!vehicleId) return undefined;

    const refresh = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/vehicle/id`, {
          params: { vehicleId, organizationId }, withCredentials: true,
        });
        const assignments = response.data.vehicle?.vehicleSchedule || [];
        const ids = [...new Set(assignments
          .filter((assignment) => !assignment.schedule?.isDeleted)
          .map((assignment) => assignment.scheduleId)
          .filter(Boolean))];
        const schedules = await Promise.all(ids.map(async (scheduleId) => {
          const result = await axios.get(`${config.baseURL}/schedule/id`, {
            params: { scheduleId }, withCredentials: true,
          });
          return result.data;
        }));
        if (!cancelled) setTiming(buildScheduleTiming(schedules));
      } catch (error) {
        if (!cancelled) setTiming(null);
      } finally {
        if (!cancelled) timer = setTimeout(refresh, 60000);
      }
    };
    refresh();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [vehicleId, organizationId]);

  return timing;
}
